import { useEffect, useRef, useState } from "react";
import {
  GetEmbalagensPorTipoDeEmbalagens,
  GetEmbalagensVinculadas,
  PatchEmbalagemPorTipoEmbalagem,
  PostEmbalagemPorTipoEmbalagem,
  PostNewDefects,
  UpdateDefectsPorTipoEmbalagem,
} from "../../../data/services";
import ModalSelecaoEmbalagens from "./components/ModalSelecaoEmbalagens";
import ModalSelecaoDefeitos from "./components/ModalSelecaoDefeitos";
import "./components/modal.css";

interface EditarTipoEmbalagemProps {
  val: {
    idTipoEmbalagem: number;
    tipoEmbalagem: string;
  };
  defeitos: any[];
}

const EditarTipoEmbalagem = ({ val, defeitos }: EditarTipoEmbalagemProps) => {
  const defeitosOriginais = useRef<any>([]);
  const embalagensOriginais = useRef<any>([]);
  const [OpenSelect, setOpenSelect] = useState(false);
  const [openSelectEmbalagem, setOpenSelectEmbalagem] = useState(false);
  const [
    sqlTodasEmbalagensPorTipoDeEmbalagem,
    setSqlTodasEmbalagensPorTipoDeEmbalagem,
  ] = useState<any>([]);

  const [
    defeitosDisponiveisParaAdicionar,
    setDefeitosDisponiveisParaAdicionar,
  ] = useState<any>([]);
  const [embalagensParaAdicionar, setEmbalagensParaAdicionar] = useState<any>(
    []
  );

  const [defeitosVinculados, setDefeitosVinculados] = useState<any[]>([]);
  const [embalagensVinculadas, setEmbalagensVinculadas] = useState<any>([]);

  const [filtroDefeito, setFiltroDefeito] = useState("");
  const [filtroEmbalagem, setFiltroEmbalagem] = useState("");

  useEffect(() => {
    GetEmbalagensVinculadas(setEmbalagensVinculadas, val?.idTipoEmbalagem);
    GetEmbalagensPorTipoDeEmbalagens(setSqlTodasEmbalagensPorTipoDeEmbalagem);
    const vinculados =
      defeitos?.filter(
        (item: any) => item.idTipoEmbalagem == val?.idTipoEmbalagem
      ) || [];
    setDefeitosVinculados(vinculados);
  }, [defeitos, val.idTipoEmbalagem]);

  useEffect(() => {
    // Filtra os defeitos que não pertencem ao idTipoEmbalagem atual
    let retornaDefeitosParaAdicionar = defeitos
      ?.filter((item: any) => item.idTipoEmbalagem != val.idTipoEmbalagem)
      .filter(
        (item: any, index: number, self: any[]) =>
          index === self.findIndex((t) => t.tipoDefeito === item.tipoDefeito)
      )
      .sort((a: any, b: any) =>
        a.tipoDefeito.localeCompare(b.tipoDefeito, "pt-BR")
      );

    setDefeitosDisponiveisParaAdicionar(retornaDefeitosParaAdicionar);
    defeitosOriginais.current = retornaDefeitosParaAdicionar;

    // Filtra as embalagens que não pertencem ao idTipoEmbalagem atual
    let retornaEmbalagensParaAdicionar = sqlTodasEmbalagensPorTipoDeEmbalagem
      ?.filter((item: any) => item.id_tipo_embalagem != val.idTipoEmbalagem)
      .sort((a: any, b: any) => a.material.localeCompare(b.material, "pt-BR"));

    setEmbalagensParaAdicionar(retornaEmbalagensParaAdicionar);
    embalagensOriginais.current = retornaEmbalagensParaAdicionar;
  }, [defeitos, sqlTodasEmbalagensPorTipoDeEmbalagem, val.idTipoEmbalagem]);

  function filtrarDefeito(valor: string) {
    if (!valor) {
      setDefeitosDisponiveisParaAdicionar(defeitosOriginais.current);
      return;
    }
    const filter = defeitosOriginais.current.filter((a: any) =>
      a.tipoDefeito.toUpperCase().includes(valor.toUpperCase())
    );
    setDefeitosDisponiveisParaAdicionar(filter);
  }
  function filtrarEmbalagem(valor: string) {
    if (!valor) {
      setEmbalagensParaAdicionar(embalagensOriginais.current);
      return;
    }
    const filter = embalagensOriginais.current.filter((a: any) =>
      a.material.toUpperCase().includes(valor.toUpperCase())
    );
    setEmbalagensParaAdicionar(filter);
  }

  const handleOpenSelect = () => {
    setFiltroDefeito("");
    setDefeitosDisponiveisParaAdicionar(
      defeitosOriginais.current.filter(
        (def: any) =>
          !defeitosVinculados.some(
            (vinc: any) =>
              vinc.idTipoDefeito == def.idTipoDefeito &&
              vinc.idTipoEmbalagem == def.idTipoEmbalagem
          )
      )
    );
    setOpenSelect(true);
  };

  const handleAddDefect = (item: any) => {
    const object = {
      idTipoEmbalagem: val?.idTipoEmbalagem,
      tipoDefeito: item.tipoDefeito,
      deleted: 0,
    };
    PostNewDefects(object);

    setDefeitosVinculados((prev: any[]) => [
      ...prev,
      {
        idTipoDefeito: item.idTipoDefeito,
        idTipoEmbalagem: item.idTipoEmbalagem,
        tipoDefeito: item.tipoDefeito,
        deleted: 0,
      },
    ]);
    setOpenSelect(false);
  };

  const handleRemoveDefeitoVinculado = (item: any) => {
    setDefeitosVinculados((prev: any[]) =>
      prev.filter((def: any) => def.idTipoDefeito !== item.idTipoDefeito)
    );
    UpdateDefectsPorTipoEmbalagem(item.tipoDefeito, val?.idTipoEmbalagem);
    setOpenSelect(false);
  };

  const handleOpenSelectEmbalagem = () => {
    setFiltroEmbalagem("");

    setEmbalagensParaAdicionar(
      embalagensOriginais.current.filter(
        (emb: any) =>
          !embalagensVinculadas.some(
            (vinc: any) => vinc.id_material_sap == emb.id_material_sap
          )
      )
    );

    setOpenSelectEmbalagem(true);
  };

  const handleAddEmbalagemPorTipoEmbalagem = (item: any) => {
    const newEmbalagem = {
      idTipoEmbalagem: val?.idTipoEmbalagem,
      idMaterialSap: item.id_material_sap,
    };
    PostEmbalagemPorTipoEmbalagem(newEmbalagem);

    setEmbalagensVinculadas((embalagensVinculadas: any) => [
      ...embalagensVinculadas,
      {
        id_material_sap: item.id_material_sap,
        id_tipo_embalagem: val?.idTipoEmbalagem,
        material: item.material,
        id_embalagem: item.id_embalagem,
      },
    ]);
    setOpenSelectEmbalagem(false);
  };

  const handleRemoveEmbalagemPorTipoEmbalagem = (
    id_material_sap: any,
    id_tipo_embalagem: any
  ) => {
    setEmbalagensVinculadas((embalagensVinculadas: any) =>
      embalagensVinculadas.filter(
        (embalagem: any) =>
          !(
            embalagem.id_material_sap == id_material_sap &&
            embalagem.id_tipo_embalagem == id_tipo_embalagem
          )
      )
    );
    setOpenSelectEmbalagem(false);

    PatchEmbalagemPorTipoEmbalagem(id_material_sap, id_tipo_embalagem);
  };

  return (
    <>
      <div className="divInput">
        <input className="input-sign-in" value={val?.tipoEmbalagem} disabled />
        <label>Tipo de Embalagem</label>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          width: "65%",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <label style={{ color: "#66afe9", fontWeight: "bold" }}>
            Embalagens vinculadas
          </label>
          <button
            className="btn btn-info"
            style={{ outline: "none", border: "none" }}
            onClick={handleOpenSelectEmbalagem}
          >
            Adicionar Embalagem
          </button>
        </div>

        <div className="session-vinculos-objetos">
          {embalagensVinculadas.map((emb: any) => (
            <div
              key={emb.id_embalagem}
              className="session-vinculos-objeto-items"
            >
              <span style={{ marginRight: 8 }}>{emb.material}</span>
              <button
                style={{
                  background: "none",
                  border: "none",
                  color: "#d83123",
                  cursor: "pointer",
                  fontWeight: "bold",
                  fontSize: 16,
                }}
                title="Remover"
                onClick={() =>
                  handleRemoveEmbalagemPorTipoEmbalagem(
                    emb.id_material_sap,
                    val?.idTipoEmbalagem
                  )
                }
              >
                ×
              </button>
            </div>
          ))}
        </div>
      </div>

      <hr />

      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          width: "65%",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <label style={{ marginRight: 15, color: "#66afe9" }}>
            Defeitos vinculados
          </label>
          <button
            onClick={handleOpenSelect}
            className="btn btn-info"
            style={{ outline: "none", border: "none" }}
          >
            Adicionar Defeito
          </button>
        </div>
        <div className="session-vinculos-objetos">
          {defeitosVinculados.map((item: any) => {
            return (
              <div
                key={item.idTipoDefeito}
                className="session-vinculos-objeto-items"
              >
                <span style={{ marginRight: 8 }}>{item.tipoDefeito}</span>
                <button
                  style={{
                    background: "none",
                    border: "none",
                    color: "#d83123",
                    cursor: "pointer",
                    fontWeight: "bold",
                    fontSize: 16,
                  }}
                  title="Remover"
                  onClick={() => handleRemoveDefeitoVinculado(item)}
                >
                  ×
                </button>
              </div>
            );
          })}
        </div>
      </div>

      <ModalSelecaoEmbalagens
        open={openSelectEmbalagem}
        onClose={() => setOpenSelectEmbalagem(false)}
        filtro={filtroEmbalagem}
        setFiltro={(valor) => {
          setFiltroEmbalagem(valor);
          filtrarEmbalagem(valor);
        }}
        embalagens={embalagensParaAdicionar}
        onSelect={handleAddEmbalagemPorTipoEmbalagem}
      />
      <ModalSelecaoDefeitos
        open={OpenSelect}
        onClose={() => setOpenSelect(false)}
        filtro={filtroDefeito}
        setFiltro={(valor) => {
          setFiltroDefeito(valor);
          filtrarDefeito(valor);
        }}
        defeitos={defeitosDisponiveisParaAdicionar}
        onSelect={handleAddDefect}
        titulo="Defeitos"
      />

      <div
        style={{
          display: "flex",
          width: "40%",
          justifyContent: "space-around",
        }}
      >
        <div className="content-button-send">
          <button
            className="button-send"
            onClick={() => {
              window.location.reload();
            }}
          >
            Voltar
          </button>
        </div>
      </div>

      {/* {method === "post" && (
        <div
          style={{
            display: "flex",
            width: "40%",
            justifyContent: "space-around",
          }}
        >
          <div className="content-button-send">
            <button className="button-send" onClick={() => Send(val)}>
              ENVIAR
            </button>
          </div>
          <div className="content-button-send">
            <button className="button-send" onClick={() => setOpen(false)}>
              Voltar
            </button>
          </div>
        </div>
      )} */}
    </>
  );
};
export default EditarTipoEmbalagem;
